module.exports = __webpack_public_path__ + "img/graph-low.82bfef7c.svg";